import { CoachOptionInfo } from '../../interfaces/coach/CoachOptionInfo';
import { CoachShortInfo } from '../../interfaces/coach/CoachShortInfo';
import { apiService } from '../apiService';

type GetCoachesListResponse = { names: CoachShortInfo[] };

type GetCoachOptionsResponse = { coaches: CoachOptionInfo[] };

export const coachService = {
  async getCoachesList(isRunGlobalSpinner: boolean = true) {
    const resp = await apiService.get<GetCoachesListResponse>(
      `/api/admin/coaches-short-list`,
      { isRunGlobalSpinner },
    );

    return resp.data;
  },

  async reassignCoachForCustomers(coachId: number, userIds: number[]) {
    const data = { ids: userIds };

    const resp = await apiService.put(`/api/admin/assign/coach/${coachId}`, data);

    return resp.data;
  },

  async getCoachOptions(entityId: number) {
    const resp = await apiService.post<GetCoachOptionsResponse>(
      `/api/entity/${entityId}/coach-list`,
    );

    return resp.data;
  },
};
